import { ca } from '@cian/analytics';

type TParams = {
  chatId: string;
  label: 'Copy' | 'Delete_message' | 'Reply' | 'Save_as_template';
  opponentId?: number;
  withPhoto?: boolean;
  isReply?: boolean;
};

export function trackMessageMenuClick({ chatId, label, withPhoto = false, opponentId, isReply }: TParams) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'Chat',
    label,
    name: 'oldevent',
    page: {
      extra: {
        chat_id: chatId,
        opponent_id: opponentId,
        is_reply: isReply,
        with_photo: label === 'Delete_message' ? withPhoto : undefined,
        type: label === 'Delete_message' ? 'chat' : undefined,
      },
    },
  });
}
